import type * as THREE from "three";

/**
 * Lightweight container for the renderer refs the HUD needs to project
 * world-space anchors to screen coordinates (EnemyMeter billboards, damage
 * numbers, tooltip arrows).
 *
 * `main.tsx` creates a SceneManager and calls `setRendererContext({ camera,
 * canvas })` before the first frame. UI components read the refs via
 * `getRendererContext()` on every RAF tick. When no map is loaded the
 * context is null and consumers skip work.
 */
export interface RendererContext {
  readonly camera: THREE.Camera;
  readonly canvas: HTMLCanvasElement;
}

let _context: RendererContext | null = null;

export function setRendererContext(ctx: RendererContext | null): void {
  _context = ctx;
}

export function getRendererContext(): RendererContext | null {
  return _context;
}
